import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import plugins from "./plugins" // plugins
Vue.use(plugins)

// rem
import "./rem.js"

// 数字滚动
import VueCountUp from "vue-countupjs" //引入
Vue.component("VueCountUp", VueCountUp)

// ant-design-vue
import Antd from "ant-design-vue"
import "ant-design-vue/dist/antd.css"
Vue.use(Antd)

import { message } from "ant-design-vue";
Vue.prototype.$message = message;

import watermark from "@/utils/watermark";
Vue.directive("watermark", watermark);

// 公共样式
import "@/assets/styles/index.scss" // global css

// 查看大图
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
Vue.use(Viewer);

import VueClipboard from "vue-clipboard2"
Vue.use(VueClipboard)

const dayjs = require("dayjs")
var utc = require("dayjs/plugin/utc")
var timezone = require("dayjs/plugin/timezone") // 依赖 utc 插件
dayjs.extend(utc)
dayjs.extend(timezone)
Vue.prototype.$dayjs = dayjs

// console.log(dayjs("2014-06-01 12:00").tz("Asia/Shanghai").format("YYYY-MM-DD HH:mm:ss"))

store.dispatch("loadLocal");
store.dispatch("getAreaList");
store.dispatch("getAddressList");

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app")
